import Rebase from 're-base';
import {usrObjMaker} from './helper';

export const base = Rebase.createClass({
      apiKey: "AIzaSyB0IYMtaN--_MHMEvHlwXMInjjzyPC2E_E",
      authDomain: "actioncyspecsearch.firebaseapp.com",
      databaseURL: "https://actioncyspecsearch.firebaseio.com",
      storageBucket: "actioncyspecsearch.appspot.com",
    });

export function updateUserProfile(usrObj, callback) {
  const user = base.auth().currentUser;

  user.updateProfile(usrObj)
  .then(function() {
    const msgObj = {message: {header:'Success', positive:true, list:['We\'ve updated your profile.']}}
    return callback(msgObj)
  }, function(error) {
    const msgObj = {message: {header:'An error occured', negative:true, list:['We didn\'t update your profile']}}
    console.error(error);
    return callback(msgObj)
  });

}

export function updateUserEmail(email, callback) {
  const user = base.auth().currentUser;

  user.updateEmail(email)
    .then(function() {
    const msgObj = {message: {header:'Success', negative:true, list:['We did update your email address. Please verify via the link we just emailed you.']}}
    return callback(msgObj);
  }, function(error) {
    const msgObj = {message: {header:'An error occured', negative:true, list:['We couldn\'t update your email address.']}}
    console.error(error);
    return callback(msgObj);
  });
}

export function editUserProfile(usrObj) {
  const timestamp = Date.now();
  const { displayName, photoURL, email} = usrObj;

  // function addNewUser() {
    base.post(`userProfiles/${usrObj.uid}/`,{
      data: {
        displayName,
        photoURL,
        email,
        lastLoggedIn: timestamp },
      then(err){
        if(err)
        console.error(err);
      }
    })
}

export function getReturningUser(usrObj, fn) {
  let tmpUsrObj;

  base.fetch(`userProfiles/${usrObj.uid}/`,{
    context: {},
    asArray: false,
    then(data) {
      tmpUsrObj = data;
      tmpUsrObj.uid = usrObj.uid;
      return fn(usrObjMaker(tmpUsrObj));
    },
    onFailure() {
      console.error('no existing user found');
    }
  })
}

export function userReturns(usrObj) {
  let timestamp = Date.now();
  base.post(`userProfiles/${usrObj.uid}/`, {
    data: {lastLoggedIn: timestamp},
    then(err) {
      if(err) {
        console.log(err);
      }
    }
  })

}



// WEBPACK FOOTER //
// ./src/helper/base-helper.js